import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from "react-ga4";
import analyticsService from './lib/AnalyticsService';

import './index.css';
import './components/firebase'; // Import firebase.js here!

import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize analytics services
ReactGA.initialize("G-QPCNYHBFTY");
analyticsService.init();

// Track any uncaught errors
window.addEventListener('error', (event) => {
  analyticsService.trackError('uncaught_javascript_error', event.error, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    fatal: true
  });
});

// Track unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  analyticsService.trackError('unhandled_promise_rejection', event.reason, {
    fatal: true
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppWrapper />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
